"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = required;

var _utils = require("../utils");

var _lib = require("../lib");

function required(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertStringOrNumber)(value);
  var message = options.message;
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);

  if (typeof value === 'string' && value.length === 0) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " is required"));
  }

  return validity;
}